import { render } from "./SingularActivityDetail.vue?vue&type=template&id=3879f0da"
import script from "./SingularActivityDetail.vue?vue&type=script&lang=js"
export * from "./SingularActivityDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__